<template>
  <div
    class="flex items-center"
    :class="{ 'cursor-pointer': enableViewModal }"
    @click="showModal()"
  >
    <div class="flex-shrink-0" :class="`w-${width}`">
      <ProfileImage :connection="connection" :border="false" />
    </div>
    <div class="flex flex-col ml-4">
      <p :title="connection.name" class="clamp-1 pr-1 overflow-ellipsis">
        {{ connection.name }}
      </p>
      <p
        :title="jobDetailsTitle"
        class="text-xs text-truegray-500 clamp-1 pr-1"
      >
        <template v-if="showFullJobDetails">
          <span>{{ connection.job_title }}</span>
          <span v-if="!hideCompany">- {{ connection.company }}</span>
        </template>
        <template v-else>
          <span>{{ connection.company }}</span>
        </template>
      </p>
      <p
        v-if="enableViewModal"
        class="text-truegray-700 font-bold text-xs hover:text-primary mt-2"
      >
        view
      </p>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import ProfileImage from './ImageConnection.vue'
import { useStore } from '../../../../js/store/index.js'
import { EventBus } from '../../../../js/plugins/event-bus'

export default defineComponent({
  name: 'ListConnection',
  components: { ProfileImage },

  props: {
    connection: {
      type: Object,
      required: true,
    },

    width: {
      type: Number,
      default: 12,
    },

    hideCompany: {
      type: Boolean,
      default: false,
    },

    enableViewModal: {
      type: Boolean,
      default: false,
    },

    cloudPostContext: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const store = useStore()

    const user = computed(() => store.getters['shared/getUser'])
    const isContributor = computed(() => store.getters['shared/isContributor'])
    const currentPost = computed(() => store.getters['shared/getCurrentPost'])
    const currentCloudPost = computed(
      () => store.getters['shared/getCurrentCloudPost'],
    )

    const showFullJobDetails = computed(() => {
      return props.connection.job_title && props.connection.company
    })

    const jobDetailsTitle = computed(() => {
      if (showFullJobDetails.value) {
        return `${props.connection.job_title} - ${props.connection.company}`
      }

      return props.connection.company
    })

    const showModal = async () => {
      if (props.enableViewModal) {
        const action = isContributor.value
          ? 'contributors/dispatchUpdateConnection'
          : 'connections/dispatchUpdateConnection'
        const actionData = { connectionId: props.connection.id }
        if (!isContributor.value) {
          actionData.data = {
            user: user.value,
          }
          if (currentCloudPost.value?.id || currentPost.value?.cloud_post_id) {
            actionData.data.postId = props.cloudPostContext
              ? currentCloudPost.value.id
              : currentPost.value?.cloud_post_id
          }
        }

        const connectionData = await store.dispatch(action, actionData)

        EventBus.$emit('showModal', {
          action: 'connection-profile',
          data: {
            connection: connectionData,
          },
        })
      }
    }
    return { showFullJobDetails, jobDetailsTitle, showModal }
  },
})
</script>
